import React from 'react';

import { withFormField } from '@gogame/form';

import ApplicationREs from './ApplicationREs';
import REPicker from './REPicker';

export const ApplicationREField = withFormField({
  grow: 1,
  padding: '',
})(({ value: fieldValue, area, onChange, loading }) => {
  const data = {
    ...area.data,
  };

  return (
    <ApplicationREs
      values={fieldValue}
      onChange={onChange}
      data={data?.['affiliates'] || []}
      loading={area.loading || loading}
      availableLabel={'Track RE off'}
      selectedLabel={'Track RE on'}
    >
      {(categoryProps) => <REPicker {...categoryProps} />}
    </ApplicationREs>
  );
});
